/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

export type InterviewRecoveryReason =
  (typeof InterviewRecoveryReason)[keyof typeof InterviewRecoveryReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewRecoveryReason = {
  expired: 'expired',
  application_removed: 'application_removed',
} as const;
